import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useConfirmDelivered } from '@/hooks/item';
import { ItemConfirmDeliveredModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const ItemConfirmDelivered: React.FC<{ modal: ItemConfirmDeliveredModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;
  const itemR = useItem(item.productId, false);
  // BE required parseInt before sending for this API
  const submitR = useConfirmDelivered({
    tmsShipmentId: parseInt(item?.shipmentInfo?.tmsShipmentId || ''),
    buyerId: parseInt(item.buyerId || ''),
    productId: item.productId,
  });

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_confirm_delivered.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_confirm_delivered.title')}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <div className={clsx([styles.text0875rem, styles.paddingY1rem])}>
        <p>
          {t('modal.item_confirm_delivered.item')} #{item.productId}
        </p>
        <p>
          {t('modal.item_confirm_delivered.tracking')} #{item.trackingNumber}
        </p>
        <div className={clsx([styles.paddingTop1rem, styles.breakLineWithEnter])}>
          <p>{t('modal.item_confirm_delivered.description')}</p>
        </div>
      </div>
    );

  return (
    <StandardModal
      title={t('modal.item_confirm_delivered.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 400 }}
      modalName="item_confirm_delivered"
    />
  );
};

export default ItemConfirmDelivered;
